import script from "./ChurnPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChurnPaymentPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./ChurnPaymentPopUp.vue?vue&type=style&index=0&id=7ef1fc2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef1fc2c"]])

export default __exports__